import {
  UPDATE_TABLE,
  RESET_TABLE,
  LOAD_MODEL,
  RESIZE_TABLE,
  COLAPSE_DASH,
  GET_TABS,
  SWITCH_TAB, SET_SELECTION_ELEMENTS, CHANGE_CHECKBOX, CHANGE_COLUMN_CHECKBOX
} from "../constans";
import { markModel } from "../../utils/builder/ITestLogic";

const initState = {
  tabs: [],
  offSetSize: 250,
  colapsedDash: "opened",
  selectedOptions: []
};
const tableReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case UPDATE_TABLE:
      const inactiveTabs = state.tabs.filter((tab) => tab.type !== '').map((tab) => { return {...tab, active: false} });

      return {
        ...state,
        tabs: [{...payload, id: 1, name: "Report", active: true, collection: {groupBy: payload.groups, properties: payload.properties} }, ...inactiveTabs],
      };
    case RESET_TABLE:
      return {
        ...initState,
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };
    case RESIZE_TABLE:

      return {
        ...initState,
        offSetSize: payload,
      };
    case COLAPSE_DASH:
      return {
        ...state,
        colapsedDash: payload,
      };
    case LOAD_MODEL:

      return {
        ...initState,
        offSetSize: state.offSetSize,
        colapsedDash: state.colapsedDash,
      };
    case GET_TABS:

      const newTabs = payload.map((tab, index) => {
        if(index === 0){
          return {...tab, id: index, active: true}
        } else {
          return {...tab, id: index, active: false}
        }
      })

      return {
        ...state,
        tabs: newTabs,
      };
    case SWITCH_TAB:

      const newActiveTab = state.tabs.map((tab) => {
        if(tab.id === payload) {
          return {...tab, active: true}
        } else {
          return {...tab, active: false}
        }
      })

      markModel([], []);

      return {
        ...state,
        tabs: newActiveTab,
        selectedOptions: [],
      };
    case SET_SELECTION_ELEMENTS:

      const newSelectedTabs = state.tabs.map((tab) => {
        if(tab.id === payload.id) {
          return {...tab, selectItems: payload.selectItems};
        } else {
          return tab;
        }
      })

      return {
        ...state,
        tabs: newSelectedTabs,
      };
    case CHANGE_CHECKBOX:

      let newSelectedOptions = null;

      if(payload.checked) {
        newSelectedOptions = state.selectedOptions.filter((el) => {
          if(el.id !== payload.id) {
            return {...el, checked: false}
          }
        })
      } else {
        newSelectedOptions = [...state.selectedOptions, {...payload, checked: true}]
      }

      const result = newSelectedOptions.reduce((previousValue, currentValue) => {

        return {
          lineElements: new Set([...previousValue.lineElements, ...currentValue.lineElements]),
          missingProperties: new Set([...previousValue.missingProperties, ...currentValue.missingProperties])
        };

      }, {lineElements: [], missingProperties: []});

      markModel(result.lineElements, result.missingProperties);

      return {
        ...state,
        selectedOptions: newSelectedOptions,
      }
    case CHANGE_COLUMN_CHECKBOX:

      let newSelectedHeaderOptions = null;

      if(payload.checkedHeader) {
        newSelectedHeaderOptions = state.selectedOptions.filter((el) => {
          if(!el.id.includes(payload.name)) {
            return {...el, checked: false}
          }
        })
      } else {
        newSelectedHeaderOptions = payload.selectedOptions;

        state.selectedOptions.forEach((elExists) => {
          newSelectedHeaderOptions = newSelectedHeaderOptions.filter((elNew) => {
            if(elExists.id !== elNew.id) {
              return elExists
            }
          })
        })
        newSelectedHeaderOptions = [...newSelectedHeaderOptions, ...state.selectedOptions];
      }

      const resultColumn = newSelectedHeaderOptions.reduce((previousValue, currentValue) => {

        return {
          lineElements: new Set([...previousValue.lineElements, ...currentValue.lineElements]),
          missingProperties: new Set([...previousValue.missingProperties, ...currentValue.missingProperties])
        };

      }, {lineElements: [], missingProperties: []});

      markModel(resultColumn.lineElements, resultColumn.missingProperties);

      return {
        ...state,
        selectedOptions: newSelectedHeaderOptions,
      }
    default:
      return state;
  }
};
export default tableReducer;
